import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ "copy" ]
  copy() {
    this.copyTarget.select()
    document.execCommand("copy")
  }
}
